import ReactSelect from 'react-select';

import Label from '@components/atoms/label';
import { TeamBadge } from '@components/transfers/TeamBadge';

type TeamOption = {
  value: string;
  label: string;
};

type TeamFilterProps = {
  teams?: { shortName: string; name: string }[];
  selectedTeams: string[];
  onChange: (next: string[]) => void;
};

// Matches the compact SelectBox baseline beside it: 14px label, 6px gap,
// 38px control (react-select's default min-height).
const LABEL_CLASS_NAME = 'flex text-sm mb-1.5';

// Mirrors the custom-transfers team/player multi-select (react-select isMulti):
// picking teams brings them to the top of the ticker and dims the rest, which
// FixtureAnalyserTable already handles off the selectedTeams short names.
export const TeamFilter = ({
  teams = [],
  selectedTeams,
  onChange
}: TeamFilterProps) => {
  const options: TeamOption[] = teams
    .map((team) => ({ value: team.shortName, label: team.name }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const value = options.filter((option) =>
    selectedTeams.includes(option.value)
  );

  return (
    <div>
      <Label htmlFor="fixture-ticker-team-filter" className={LABEL_CLASS_NAME}>
        Teams
      </Label>
      <div data-cy="fixture-ticker-team-filter">
        <ReactSelect
          isMulti
          isSearchable={false}
          menuPlacement="auto"
          placeholder="All teams"
          name="fixture-ticker-team-filter"
          options={options}
          value={value}
          onChange={(selected) =>
            onChange((selected ?? []).map((option) => option.value))
          }
          formatOptionLabel={(option) => (
            <span className="flex items-center gap-2">
              <TeamBadge shortName={option.value} size="sm" />
              {option.value}
            </span>
          )}
        />
      </div>
    </div>
  );
};
